import { apiRequest} from './index'

export const getLettersRequest = (filters) => {

  const {
    page=0,
    limit=0,
    search='',
    status='',
    client='',
    type='',
    subtype='',
    simplified='true',
    project=''
  } = filters;

  return apiRequest(
    `/admin/letters?page=${page}&limit=${limit}&search=${search}&status=${status}&client=${client}&type=${type}&subtype=${subtype}&simplified=${simplified}&project=${project}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getLetterRequest = (id) => {
  return apiRequest(
    `/admin/letters/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const createLetterRequest = (letter) => {
  return apiRequest(
    `/admin/letters`,
    {
      method: 'POST',
      body: JSON.stringify(letter)
    },
    true
  )
}

export const updateLetterRequest = (letter) => {
  return apiRequest(
    `/admin/letters/${letter._id}`,
    {
      method: 'PUT',
      body: JSON.stringify(letter)
    },
    true
  )
}

export const deleteLetterRequest = (letterId) => {
    return apiRequest(
      `/admin/letters/${letterId}`,
      {
              method: 'DELETE'
      },
      true
    )
  }

export const markLettersAsSent = (data) => {
  return apiRequest(
    `/admin/letters/mark-as-sent`,
    {
			method: 'POST',
      body: JSON.stringify(data)
    },
    true
  )
}